var render, staticRenderFns
import script from "./ArtworkGrid.vue?vue&type=script&lang=js"
export * from "./ArtworkGrid.vue?vue&type=script&lang=js"
import style0 from "./ArtworkGrid.vue?vue&type=style&index=0&id=73a84a4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports